import * as React from 'react'
import location from '../../assets/location.svg'
const backgroundIllu = require('../../assets/background-illu.png')

interface BackgroundProps {
  style?: React.CSSProperties
}

const Background: React.SFC<BackgroundProps> = ({ children, style }) => {
  return (
    <div
      style={{
        background: 'linear-gradient(158.56deg, #1D3557 4.27%, #1D3557, #A8DADC',
        height: '100vh',
        width: '100vw',
        position: 'relative',
        ...style,
      }}
    >
      <img
        style={{
          height: '100%',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          opacity: 0.4,
        }}
        src={backgroundIllu}
      />
      <img
        style={{
          width: '95%',
          height: '95%',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          opacity: 0.2,
        }}
        src={location}
      />
      {children}
    </div>
  )
}

export default Background



// WEBPACK FOOTER //
// ./src/components/background/Background.tsx